export const CUSTOM_PROPERTY_GROUP_NAME: string = "artikelgroep_vorm_omschrijving"; // used as product title

export const CUSTOM_PROPERTY_GROUP_MATERIAL: string = "artikelgroep_materiaal_omschrijving"; // used as product sub title

export const CUSTOM_PROPERTY_ARTICLE_GROUP: string = "artikelgroep"; // used for show all variant button on the variant page

export const CUSTOM_PROPERTY_FINISH: string = "nabehandeling"; // used as product sub title

export const CUSTOM_PROPERTY_PRICE_UNIT_VALUE: string = "price_unit"; // used for price display

export const CUSTOM_PROPERTY_PRICE_UNIT_NAME: string = "eenheid"; // used for price display

export const CUSTOM_PROPERTY_BRAND: string = "merk"; // used for brand linkage

export const CUSTOM_PROPERTIES_FOR_PDP_INFO = [
  "artikelgroep",
  "din_nummer",
  "iso_nummer",
  "artikelgroep_vorm_omschrijving",
]; // used as featured properties on product details page

export const CUSTOM_PROPERTIES_FOR_VARIATION_TABLE = ["eenheid", "price_unit"]; // used as column in variant table view on product details page

export const CUSTOM_PROPERTIES_FOR_GROUP_TILES = ["din_nummer", "iso_nummer"]; // used on product tiles

export const CUSTOM_PROPERTIES_FOR_LINE_ITEMS = [
  "artikelgroep_vorm_omschrijving",
  "artikelgroep_materiaal_omschrijving",
  "nabehandeling",
];

export const CUSTOM_PROPERTIES_PDP_LIST_EXCLUDES = [
  "naar_webshop",
  "status_artikel_niet_meer_verkopen",
  "naar_catalogus",
  "intrastat",
  "saleslayer_new_product",
  "price_unit",
  "eenheid",
]; // these properties will NOT be shown in the list on product details page

export const CUSTOM_PROPERTIES_FOR_5_FEATURED_PRODUCTS = [
  "din_nummer",
  "iso_nummer",
  "materiaal",
  "nabehandeling",
  "metrisch",
  "diameter",
];
